<template>
  <div>
    <!-- page meta -->
    <Head>
      <title>High Converting Course Software by Platforma</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Advanced Course creation for entrepeneurs that need more moentization features."
      />
    </Head>
  </div>
  <!-- content start -->

  <!-- =======CONTAINER START======== -->

  <div
    class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
    :style="backgroundImageStyleMain"
  >
    <!-- ===================== HERO SECTION ===================== -->

    <section
      id="section1"
      class="hero-section relative mx-auto mt-[150px] justify-center gap-1 bg-transparent lg:flex lg:py-0"
    >
      <div class="mt-0 bg-transparent px-[25px] xl:px-0">
        <h1
          class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Convert stronger with the perfect course solution.
        </h1>

        <p
          class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
        >
          The most advanced digital marketing tactics and features rolled into
          one place.
        </p>

        <!-- captcher email widget -->

        <EmailCaptureHeaderWidget />

        <img :src="$filters.media_path('/images/stars.svg')" alt="" />
      </div>

      <div class="mb-[30px] mt-[30px] lg:mt-0 z-10">
        <img
          loading="lazy"
          class="lg:max-w-[650px]"
          :src="
            $filters.media_path(
              '/images/platforma-online-course-builder-with-modules-and-lessons.png'
            )
          "
          alt="Best way to monetize social media by moving followers OFF social media."
        />
      </div>
    </section>

    <div
      class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[150px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
    >
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      <h2
        class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
      >
        JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
      </h2>
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
    </div>

    <!-- ===================== CROSS SELL SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:flex lg:h-[500px] xl:px-0"
    >
      <img
        class="absolute top-10 left-[600px] z-0 hidden h-[600px] w-[810px] origin-top-right lg:block"
        :src="$filters.media_path('/images/blue_gradient.svg')"
        alt=""
      />

      <div class="z-20 mx-auto mt-12 justify-center gap-1 py-0 lg:flex">
        <div class="mt-0 text-center lg:max-w-[500px] lg:text-left">
          <div
            id="text_cross_sell"
            class="text-xs font-extrabold text-[#2D8CFF]"
          >
            CROSS SELL
          </div>

          <h2
            class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Advanced courses all in one login.
          </h2>

          <hr
            class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#2D8CFF] lg:ml-0"
          />

          <p
            class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
          >
            Speed up the customer journey with unlimited amount of courses under
            one log in. Members can unlock additional products with a simple
            mouse click.
          </p>
        </div>

        <div class="z-30 mt-[25px] xl:mt-0">
          <img
            loading="lazy"
            class="lg:w-[650px] hover:scale-[105%] hover:ease-in-out duration-700"
            :src="
              $filters.media_path('/images/login-to-members-area-course.png')
            "
            alt="Creator UI of video channels with videos being uploaded to their private members area."
          />
        </div>
      </div>
    </section>

    <!-- ===================== REWARDS SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[200px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
    >
      <img
        class="absolute top-0 right-[600px] z-0 h-[600px] w-[810px] origin-top-left overflow-hidden"
        :src="$filters.media_path('/images/green-diamond-dots-bg.svg')"
        alt=""
      />

      <div
        class="mt-12 text-center lg:mx-0 lg:mt-0 lg:max-w-[500px] lg:px-[30px] lg:text-left"
      >
        <div
          id="text_rewards"
          class="text-xs font-extrabold text-[#27AE60] lg:left-0"
        >
          REWARDS
        </div>

        <h2
          class="top-full px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] md:mt-[20px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Map progression with quizzes and certificates.
        </h2>

        <div class="">
          <hr
            class="m-auto mt-[30px] h-[5px] w-[100px] rounded-full bg-[#27AE60] lg:ml-0"
          />
        </div>

        <p
          class="mt-[50px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[440px]"
        >
          Give students something to work towards with quizzes they can crush at
          the end of each lesson, and a customizable certificate of completion
          to confirm their success .
        </p>
      </div>

      <div
        class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
      >
        <img
          loading="lazy"
          class="lg:w-[675px] hover:scale-[105%] hover:ease-in-out duration-700"
          :src="
            $filters.media_path('/images/course-quizzes-added-to-lessons.png')
          "
          alt="Give students quizzes for each lesson they take in their course."
        />
      </div>
    </section>
  </div>

  <!-- ============= EMAIL INTEGRATIONS ============= -->

  <TransparentBgTabs />

  <!-- ============= EMAIL INTEGRATIONS ============= -->

  <EmailIntegrationsSlider />

  <!-- SEXY TESTIMONIALS SECTION -->

  <section
    class="testimonial-blue-quotes mx-auto mt-[50px] lg:mt-[100px] max-w-[1200px] px-[25px] text-center xl:px-0"
  >
    <CarouselTestimonialBlueQuotes
      :pagination="true"
      :timeout="5000"
      class="carousel xl:w-[1100px] md:h-[450px] h-[350px] pt-[50px] bg-none relative mx-auto my-auto py-0"
      v-slot="{ currentSlide }"
    >
      <SlideBlueQuotesTestimonials
        v-for="(slideBlueQuotesTestimonials, index) in carouselSlides"
        :key="index"
      >
        <div
          v-show="currentSlide == index + 1"
          class="slide-info absolute mx-auto bg-none w-full h-full rounded-[10px] sm:rounded-[60px]"
        >
          <img
            :src="
              $filters.media_path(`/images/${slideBlueQuotesTestimonials}.png`)
            "
            alt="Build your own podcast delivery website on your own domain to make more revenue from your Podcast."
            class="mx-auto md:w-[800px] shadow-2xl"
          />
        </div>
      </SlideBlueQuotesTestimonials>
    </CarouselTestimonialBlueQuotes>
  </section>
  <!-- ===================== CTA BLOCK ===================== -->
  <CtaBlock
    cta-headline="Start using Platforma Courses 
and make more every month."
  />
</template>

<!-- =======CONTENT END======== -->

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import Axios from 'axios';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import EmailIntegrationsSlider from '../Components/EmailIntegrationsSlider.vue';
import TransparentBgTabs from '../Components/TransparentBgTabs.vue';
import CarouselTestimonialBlueQuotes from '../Components/CarouselTestimonialBlueQuotes.vue';
import SlideBlueQuotesTestimonials from '../Components/SlideBlueQuotesTestimonials.vue';
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';

export default {
  layout: DefaultLayout,
  components: {
    ButtonComponent,
    EmailCaptureHeaderWidget,
    EmailIntegrationsSlider,
    TransparentBgTabs,
    CarouselTestimonialBlueQuotes,
    SlideBlueQuotesTestimonials,
    CtaBlock
  },

  setup() {
    const carouselSlides = [
      'testimonial-blue-1-course-creators',
      'testimonial-blue-2-course-creators',
      'testimonial-blue-3-course-creators'
    ];

    return { carouselSlides };
  },

  computed: {
    backgroundImageStyleMain() {
      const imagePath = this.$filters.media_path(
        'images/platforma-header-background-eclipse.svg'
      );
      return {
        '--before-background-image': `url(${imagePath})`
      };
    }
  }
};
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}

.testimonial-blue-quotes {
  background-image: url(../media/images/two-dots.svg);
}
</style>
